import { PageOwnerIdentity } from '../dto/EntityRepository';

export const isPageOwnerMatchedToRaw = (
  raw: string | undefined,
  pageOwner: PageOwnerIdentity | null,
): boolean => {
  if (!raw || !pageOwner) return false;
  return raw === `@${pageOwner.handle}` || raw === pageOwner.aui;
};
